module.exports = __webpack_public_path__ + "media/images/common-nav/state-parks/texas-8bcb2fc0a4f0c8131368e9b721666c56.jpg";